var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFileGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 7.5C0.625 3.70305 3.70304 0.625 7.5 0.625H27.4671C28.8765 0.625 30.1995 1.30393 31.0213 2.44887L38.5542 12.9436C39.0879 13.6872 39.375 14.5794 39.375 15.4947V42.5C39.375 46.297 36.297 49.375 32.5 49.375H7.5C3.70304 49.375 0.625 46.297 0.625 42.5V7.5ZM7.5 4.375C5.77411 4.375 4.375 5.77411 4.375 7.5V42.5C4.375 44.2259 5.77411 45.625 7.5 45.625H32.5C34.2259 45.625 35.625 44.2259 35.625 42.5V17.2426H27.5C26.4645 17.2426 25.625 16.4031 25.625 15.3676V4.375H7.5Z",
    fill: "lightgray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7142 28.0463C27.0673 28.8549 25.8874 28.986 25.0788 28.3391L21.8751 25.7762V34.375C21.8751 35.4105 21.0357 36.25 20.0001 36.25C18.9646 36.25 18.1251 35.4105 18.1251 34.375V25.7761L14.9214 28.3391C14.1128 28.986 12.9328 28.8549 12.2859 28.0463C11.639 27.2377 11.7701 26.0578 12.5788 25.4109L18.8221 20.4162C19.1402 20.159 19.5442 20.0037 19.9843 20.0001C19.9896 20 19.9949 20 20.0001 20L20.0062 20C20.454 20.0014 20.8648 20.1598 21.1865 20.423L27.4214 25.4109C28.23 26.0578 28.3611 27.2377 27.7142 28.0463Z",
    fill: "lightgray"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileGray);
export default __webpack_public_path__ + "static/media/icon_file_gray.9b086bfd471feb215a262bd5486563d5.svg";
export { ForwardRef as ReactComponent };